// LUCKY DUCKY · PHASE 2 · Developer simulator UI
// Route: /casino/lucky-ducky/sim   (admin-only view)
// Runs the SAME evaluator as the playable game (engine/simulator.js) and
// prints the full Phase 2 telemetry set for calibration/QA review.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { simulate } from './engine/simulator';
import { WAGER_KEYS } from './engine/wager';

const LuckyDuckySim = () => {
  const navigate = useNavigate();
  const [spins, setSpins] = useState(50000);
  const [wagerKey, setWagerKey] = useState('PLAY_1X');
  const [running, setRunning] = useState(false);
  const [report, setReport] = useState(null);

  const run = async () => {
    setRunning(true);
    setReport(null);
    // Yield so the button "flips" before the compute starts.
    await new Promise(r => setTimeout(r, 30));
    const started = performance.now();
    const r = simulate({ spins, wagerKey });
    r.__elapsed_ms = Math.round(performance.now() - started);
    setReport(r);
    setRunning(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#050810', color: '#dfe7fb',
                  fontFamily: 'ui-monospace, Menlo, Consolas, monospace', padding: 16, overflow: 'auto' }}
         data-testid="lucky-ducky-sim-page">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <button onClick={() => navigate('/casino/lucky-ducky')}
                style={{ background: '#0a2255', color: '#ffcf3a', border: '1px solid #ffcf3a',
                         padding: '6px 12px', borderRadius: 8, cursor: 'pointer' }}
                data-testid="ld-sim-back">← Game</button>
        <h1 style={{ margin: 0, color: '#ffcf3a', fontFamily: 'Arial Black' }}>Lucky Ducky · Cardinal V2 Simulator</h1>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 20, flexWrap: 'wrap' }}>
        <label>Spins:
          <input type="number" value={spins} onChange={e => setSpins(Number(e.target.value) || 1)}
                 style={{ marginLeft: 6, background: '#082456', color: '#fff', border: '1px solid #ffcf3a', padding: 4, borderRadius: 4, width: 120 }}
                 data-testid="ld-sim-spins" />
        </label>
        <label>Wager:
          <select value={wagerKey} onChange={e => setWagerKey(e.target.value)}
                  style={{ marginLeft: 6, background: '#082456', color: '#fff', border: '1px solid #ffcf3a', padding: 4, borderRadius: 4 }}
                  data-testid="ld-sim-wager">
            {WAGER_KEYS.map(k => <option key={k} value={k}>{k}</option>)}
          </select>
        </label>
        <button onClick={run} disabled={running}
                style={{ background: 'linear-gradient(180deg,#3cff70,#0a7530)', color: '#062812', border: '2px solid #a0ffb8',
                         padding: '8px 16px', borderRadius: 999, cursor: 'pointer', fontWeight: 900,
                         opacity: running ? 0.5 : 1 }}
                data-testid="ld-sim-run">
          {running ? 'RUNNING…' : 'RUN SIMULATION'}
        </button>
      </div>

      {report && (
        <div>
          <div style={{ padding: 10, border: '1px solid #ffcf3a', borderRadius: 8, marginBottom: 12 }}>
            <b style={{ color: '#ffcf3a' }}>Reference V7 targets:</b> RTP ~95%, feature ~1/162, bonus2+ ~1/40.5, bonus3+ ~1/739 · these are NOT hard-coded rules.
          </div>
          <pre style={{ background: '#0b1229', color: '#7ee6ff', padding: 12, borderRadius: 8,
                        border: '1px solid #4bd0ff', fontSize: 12, whiteSpace: 'pre-wrap' }}
               data-testid="ld-sim-report">
{JSON.stringify(report, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default LuckyDuckySim;
